import { render, staticRenderFns } from "./FormatReferenceTreeFilter.vue?vue&type=template&id=48d6f38c&scoped=true&"
import script from "./FormatReferenceTreeFilter.vue?vue&type=script&lang=ts&"
export * from "./FormatReferenceTreeFilter.vue?vue&type=script&lang=ts&"
import style0 from "./FormatReferenceTreeFilter.vue?vue&type=style&index=0&id=48d6f38c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d6f38c",
  null
  
)

export default component.exports